var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.174 22.042c-.135-.144-.426-.807 0-1.195.493-.45.966-.2 1.235.087L17 23.782V16c0-.5.367-1 1-1s1 .5 1 1v7.782l2.613-2.848c.27-.287.839-.4 1.187-.087.35.313.27.908 0 1.195l-4.167 4.743c-.368.431-.953.431-1.332 0l-4.127-4.743z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M10.172 0a2 2 0 0 1 1.414.586l4.828 4.828A2 2 0 0 1 17 6.828V13h-2V6.829L10.171 2H2v19h9v2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8.172z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Black, Roboto",
    fontSize: 5,
    fontWeight: 700,
    letterSpacing: 0.079
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.771,
    y: 14
  }, "PDF")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.0b8e97e7.svg";
export { ForwardRef as ReactComponent };